import type { StatisticsDistribution, StatisticsDistributionRow } from '@easyhelp/shared';

/** Schermate mostrate una per una: oltre, una riga «altre» con la somma (le righe sono già ordinate). */
export const SCREEN_ROWS_LIMIT = 10;

/** Una riga della tabella: una voce dell'API oppure l'aggregato delle voci oltre il limite. */
export interface DistributionDisplayRow extends StatisticsDistributionRow {
  other: boolean;
}

/**
 * Le righe da mostrare per una distribuzione. Le schermate possono essere molte: le prime
 * `SCREEN_ROWS_LIMIT` restano, le altre diventano una riga «Altre N schermate» con la loro somma,
 * così il totale della tabella resta quello dei lavorabili.
 */
export function displayRows(
  dimension: StatisticsDistribution,
  rows: StatisticsDistributionRow[],
  limit = SCREEN_ROWS_LIMIT
): DistributionDisplayRow[] {
  const all = rows.map((row) => ({ ...row, other: false }));
  if (dimension !== 'screen' || rows.length <= limit) return all;
  const rest = rows.slice(limit);
  return [
    ...all.slice(0, limit),
    {
      key: null,
      label: `Altre ${rest.length} schermate`,
      count: rest.reduce((sum, row) => sum + row.count, 0),
      other: true,
    },
  ];
}
